import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ProductDemo, ProductDemosData } from '../models/product-demo.model';

@Injectable({
  providedIn: 'root'
})
export class ProductDemosService {
  private readonly dataUrl = 'assets/data/product-demos.json';

  constructor(private readonly http: HttpClient) {}

  getProductDemos(): Observable<ProductDemo[]> {
    return this.http.get<ProductDemosData>(this.dataUrl).pipe(
      map(data => data.demos)
    );
  }

  getProductDemoById(id: number): Observable<ProductDemo | undefined> {
    return this.getProductDemos().pipe(
      map(demos => demos.find(demo => demo.id === id))
    );
  }
}
